import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";
import { FORM_STYLES } from "../constants";
import { PageOneFormData } from "../models";

export const FormCreationInfo = () => {
  const { t } = useTranslate();
  const { control } = useFormContext<PageOneFormData>();

  return (
    <Grid md={4} xs={12} spacing={2} sx={{ padding: "0px", paddingRight: "20px" }}>
      <Box
        sx={{
          border: FORM_STYLES.sectionBorder,
          borderRadius: FORM_STYLES.sectionBorderRadius,
          padding: FORM_STYLES.sectionPadding,
          height: "100%",
        }}
      >
        <Grid
          sx={{
            backgroundColor: FORM_STYLES.titleBackgroundColor,
            color: FORM_STYLES.titleColor,
            borderRadius: FORM_STYLES.titleBorderRadius,
          }}
        >
          <ByzMuiTypography isTitle paddingRight={FORM_STYLES.headerPaddingRight} paddingTop={FORM_STYLES.headerPaddingTop}>
            {t("adult-patient-assessment.form-creation-info")}
          </ByzMuiTypography>
        </Grid>
        <Grid sx={{ paddingTop: "20px" }}>
          <ByzMuiTypography marginLeft="0" textAlign="left">
            {t("datetime")}
          </ByzMuiTypography>
        </Grid>
        <Grid sx={{ paddingTop: "5px" }}>
          <Controller
            name="creationInfo.datetime"
            control={control}
            render={({ field }) => (
              <ByzMuiDateTimePicker
                {...field}
                sx={{ width: "100%", maxWidth: "300px" }}
              />
            )}
          />
        </Grid>
        <Grid sx={{ paddingTop: "20px" }}>
          <ByzMuiTypography marginLeft="0" textAlign="left">
            {t("createdby")}
          </ByzMuiTypography>
        </Grid>
        <Grid sx={{ paddingTop: "5px" }}>
          <Controller
            name="creationInfo.createdBy"
            control={control}
            render={({ field }) => (
              <ByzMuiTextField
                {...field}
                sx={{ width: "100%", maxWidth: "300px" }}
                disabled
                label={t("createdby")}
              />
            )}
          />
        </Grid>
      </Box>
    </Grid>
  );
};
